import React from "react";
import closeIcon from "../../assets/cross.svg";
import Export from "../../assets/export1.svg";
import SchoolLogo from "../SchoolLogo";
import SchoolStaffPanel from "../SchoolStaffPanel";

const DetailSchoolModal = ({ onClose, school, onDeactivate, onTransfer, onExport, exporting }) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center">
      {/* max-h + inner scroll: the staff roster makes this modal variable
          height, and it must not overflow the viewport on laptop screens. */}
      <div className="w-[640px] max-h-[90vh] bg-white rounded-[20px] overflow-hidden font-['Manrope'] flex flex-col">
        {/* Header */}
        <div className="px-6 py-[21px] bg-gradient-to-br from-white to-blue-100 border-b border-[#DAEBFF] flex justify-between items-center flex-shrink-0">
          <h2 className="text-[18px] font-bold text-gray-900">
            Detailed School Information
          </h2>
          <div className="flex items-center gap-3">
            <button
              onClick={onExport}
              disabled={exporting}
              className={`px-[10px] py-1.5 border border-blue-500 rounded-md flex items-center gap-1.5 transition-colors ${
                exporting ? "opacity-50 cursor-not-allowed" : "hover:bg-blue-50"
              }`}
            >
              <img src={Export} alt="Export" className="w-4 h-4" />
              <span className="text-gray-900 text-sm font-medium">
                {exporting ? "Exporting..." : "Export"}
              </span>
            </button>
            <button onClick={onClose} className="p-0.5">
              <img src={closeIcon} alt="Close" className="w-[22px] h-[22px]" />
            </button>
          </div>
        </div>

        {/* Body */}
        <div className="px-6 pb-5 flex flex-col gap-6 mt-5 overflow-y-auto">
          {/* Logo + name banner */}
          <div className="flex items-center gap-3">
            <SchoolLogo name={school?.school} logoUrl={school?.logoUrl} size={48} />
            <span className="text-gray-900 text-lg font-bold">
              {school?.school || "—"}
            </span>
          </div>

          <div className="flex flex-col gap-2">
            <div className="flex flex-col gap-3.5">
              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-base font-normal">
                  School Name
                </span>
                <span className="text-gray-900 text-base font-semibold text-right">
                  {school?.school || "—"}
                </span>
              </div>
              {/* Primary admin (School.schoolAdminId — the legacy one-to-one
                  owner). The full roster, including any additional admins,
                  lives in the staff panel below. */}
              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-base font-normal">
                  Primary Admin
                </span>
                <span className="text-gray-900 text-base font-semibold text-right">
                  {school?.adminName || "—"}
                  {school?.title ? (
                    <span className="block text-sm font-normal text-gray-500">{school.title}</span>
                  ) : null}
                  {school?.email ? (
                    <span className="block text-sm font-normal text-gray-500">{school.email}</span>
                  ) : null}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-base font-normal">
                  Date Joined
                </span>
                <span className="text-gray-900 text-base font-semibold text-right">
                  {school?.dateJoined || "—"}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-base font-normal">
                  Student Count
                </span>
                <span className="text-gray-900 text-base font-semibold text-right">
                  {school?.studentCount ?? 0}
                </span>
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex flex-col gap-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 text-base font-normal">
                      Status
                    </span>
                    <div className={`px-2.5 py-1 rounded-[40px] flex items-center ${
                      school?.status === "Active"
                        ? "bg-emerald-100"
                        : "bg-[#FEF3C7]"
                    }`}>
                      <span className={`text-sm font-medium ${
                        school?.status === "Active"
                          ? "text-emerald-800"
                          : "text-red-800"
                      }`}>
                        {school?.status || "Active"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="h-[1px] bg-gray-300"></div>

          {/* Full staff roster — a school can have many admins/owners, which
              the single "Primary Admin" field above can't represent. */}
          {school?.id ? <SchoolStaffPanel schoolId={school.id} schoolName={school.school} /> : null}

          <div className="h-[1px] bg-gray-300"></div>

          <div className="flex justify-end items-center gap-2">
            {school?.status === "Active" && (
              <>
                <button
                  onClick={onDeactivate}
                  className="h-11 px-4 py-1.5 border border-blue-500 rounded-lg hover:bg-blue-50 transition-colors"
                >
                  <span className="text-gray-900 text-base font-medium">
                    Deactivate
                  </span>
                </button>
                <button
                  onClick={onTransfer}
                  className="h-11 px-4 py-1.5 bg-blue-500 hover:bg-blue-600 rounded-lg transition-colors"
                >
                  <span className="text-white text-base font-medium leading-4">
                    Transfer Account
                  </span>
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailSchoolModal;